import { render, staticRenderFns } from "./akta.vue?vue&type=template&id=c215f56e&"
import script from "./akta.vue?vue&type=script&lang=js&"
export * from "./akta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports